import { render, staticRenderFns } from "./ExtratoComunicacaoTransferencia.vue?vue&type=template&id=5bbf333b&scoped=true&"
import script from "./ExtratoComunicacaoTransferencia.vue?vue&type=script&lang=js&"
export * from "./ExtratoComunicacaoTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoComunicacaoTransferencia.vue?vue&type=style&index=0&id=5bbf333b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf333b",
  null
  
)

export default component.exports